import {
    GETCHARGEBACKLIST_SUCCESS,
    GETCHARGEBACKLIST_FAILED,
    RESET_GETCHARGEBACKLIST,
    LOADING_GETCHARGEBACKLIST,
    NETWORK_ERROR_GETCHARGEBACKLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetChargebackList = () => {
    return { type: RESET_GETCHARGEBACKLIST };
};

const getChargebackList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETCHARGEBACKLIST });
        await partnerServices
            .post("getSuccessTransactionList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getChargebackListSuccess(res.data));
                        break;
                    default:
                        dispatch(getChargebackListFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETCHARGEBACKLIST,
                    payload: err,
                });
            });
    };

function getChargebackListSuccess(data) {
    return {
        type: GETCHARGEBACKLIST_SUCCESS,
        payload: data,
    };
}

function getChargebackListFailed(data) {
    return {
        type: GETCHARGEBACKLIST_FAILED,
        payload: data,
    };
}

export { resetGetChargebackList, getChargebackList };